export default "__VITE_ASSET__uuL1i4D$__"